export default __webpack_public_path__ + "static/small-streams-6ecddb3223f2bfd7edb034616f2d9c76.png";